const dashboard = {
  "Boarding checklist": "Boarding checklist",
  "Company data": "Company data",
  "User data": "User data",
  "Bank account": "Bank account",
  "Client application": "Client Application",
  clientApplicationExplanation: `A client application contains the code you write so that you can access the Volt API.
  You can create as many client applications as you need, using different credentials.
  For example, your website and mobile apps would normally be classed as different client applications.`,
  bankAccountExplanation: `You should provide details of the bank accounts you'd like to receive customer payments into
    in your production environment.`,
  testNotificationExplanation: "TODO",
  "Fill in data": "Fill in data",
  "Configure bank account": "Configure bank account",
  "Test notifications": "Test notifications",
  "Configure client application": "Configure client application",
};

export default dashboard;
